import styled from 'styled-components';

export const StyledModelLabel = styled.text`
    text-anchor: start;
    fill: #656565;
    font-size: 16px;
`;
